module.exports = __webpack_public_path__ + "static/media/icon_16_处置.75a33f88.svg";